<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			{{ $t('Edit User Settings') }}
		</template>
		<template slot="body">
			<form @submit.prevent="">
				<div class="d-flex">
					<div class="plan-description mb-3 col-md-8 mt-2 pl-0">
						<label class="custom-control custom-checkbox mb-3">
							<input type="checkbox" class="custom-control-input" v-model="isEnableUploadLimit">
							<h5 class="custom-control-label text-white pl-2">{{ $t('Enabled limit upload') }}</h5>
							<div class="sub-title pl-2">{{ $t('By default the upload limit is 10 Mb (free)') }}</div>
						</label>
					</div>
					<!-- limit -->
					<div class="sub-title pl-2 absolute" style="margin-left: 21.8em">{{ $t('Maximum limit is 1 GB') }}</div>
					<div class="form-group mb-3 col-md-5 mt-4 pl-0 pr-5">
						<custom-input
							type="number"
							:disabled="!isEnableUploadLimit"
							align="left"
							:min="0"
							:max="1024"
							:label="$t('Limit (Mb)')"
							v-model="uploadLimit"
						/>
					</div>
					<!-- Login multiple Device -->
				</div>
				<!-- Login multiple Device -->
				<div class="d-flex">
					<div class="plan-description mb-3 col-md-8 pl-0">
						<label class="custom-control custom-checkbox mb-3">
							<input type="checkbox" class="custom-control-input" v-model="isSpectator" @change="updateSpectator()">
							<h5 class="custom-control-label text-white pl-2">{{ $t('Login with multiple device') }}</h5>
						</label>
					</div>
				</div>
				<div class="d-flex justify-content-between">
					<div>
						<button
						@click="updateSettingLayout"
						type="submit"
						class="btn btn-submit btn-primary"
						:class="{ 'is-loading': isSavingSettings }">
						{{ $t('Update Setting') }}
						</button>
					</div>
					<div>
						<button
							@click="close"
							class="btn btn-submit btn-default ml-a mr-2">
							{{ $t('cancel') }}
						</button>
					</div>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomInput from '@/components/CustomInput.vue';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage, duplicateVar } from '@/lib/helper';
import usersApi from '@/api/user';

export default {
	name: 'UserForm',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
		CustomInput,
	},
	data() {
		return {
			settings: '',
			isSavingSettings: false,
			isEnableUploadLimit: false,
			uploadLimit: 100,
			isSpectator: false,
		};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		initData() {
			if (this.data) {
				this.setData(this.data);
			}
		},
		setData(data) {
			this.isSpectator = this.data.is_spectator;
			// @TODO: catch variable user setting if setting is undefined
			const settings = JSON.parse(data.settings);
			if (settings) {
				const settingsString = data.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = settings && settings.is_enable_advance_layout ? duplicateVar(settings.is_enable_advance_layout) : false;
				this.isEnableDummy = settings && settings.is_enable_dummy_item_data ? duplicateVar(settings.is_enable_dummy_item_data) : false;
				this.isEnableAllPreview = settings && settings.is_enable_all_preview ? duplicateVar(settings.is_enable_all_preview) : false;
				this.isEnableShowLogo = settings && settings.is_enable_show_logo ? duplicateVar(settings.is_enable_show_logo) : false;
				this.isEnableUploadLimit = settings && settings.subscription && settings.subscription.storage && settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
				this.uploadLimit = settings && settings.subscription && settings.subscription.storage && settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 100;
			} else {
			// @TODO: catch variable user setting if setting is undefined
				const settingsString = this.data.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = 0;
				this.isEnableDummy = 0;
				this.isEnableAllPreview = 0;
				this.isEnableShowLogo = 0;
				this.uploadLimit = 100;
			}
		},
		updateSettingLayout() {
			this.isSavingSettings = true;
			this.settings.is_enable_advance_layout = this.isEnableAdvance;
			this.settings.is_enable_dummy_item_data = this.isEnableDummy;
			this.settings.is_enable_all_preview = this.isEnableAllPreview;
			this.settings.is_enable_show_logo = this.isEnableShowLogo;
			this.settings.subscription.storage.is_enabled = this.isEnableUploadLimit;
			this.settings.subscription.storage.upload_size = this.uploadLimit;
			// this.settings.background_color = this.colorBackground;
			const paramsSettings = { settings: JSON.stringify(this.settings) };
			const layout = paramsSettings;
			const params = layout;
			const callback = (response) => {
				const user = response.data;
				this.$emit('saved', user);
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Settings',
					text: message,
				});
				this.close();
				this.isEnableUploadLimit = false;
				this.isSavingSettings = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Settings',
					text: message,
				});
				this.close();
				this.isSavingSettings = false;
			};
			usersApi.update(this.data.id, params, callback, errorCallback);
		},
		updateSpectator() {
			this.isSaving = true;
			const callback = (response) => {
				const user = response.data;
				const message = response.message;
				this.$emit('saved', user);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update User',
					text: message,
				});
				this.isSaving = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update User',
					text: message,
				});
				this.isSaving = false;
			};
			const params = {
				is_spectator: this.isSpectator,
			};
			usersApi.update(this.data.id, params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
	},
	created() {
		this.initData();
	},
};
</script>
